export const EVENTS = {
  buttonClick: 'button-click',
  signinLinkRedirectClicked: 'signin-link-redirect-clicked',
};
